import { Button, Modal, Spinner } from 'flowbite-react';
import { get } from 'lodash';
import React, { useContext } from 'react';
import { useMutation } from 'react-query';
import { updateRole } from 'src/apis/user';
import { useToast } from 'src/context/ToastProvider';
import { useUserContext } from 'src/context/UserProvider';
import { UserRole } from 'types';
import CompanySelectionModal from './CompanySelectionModal';

const UpdateRoleModal = () => {
	const { user } = useUserContext();
	const { showUpdateRoleModal, setShowUpdateRoleModal } = useUserContext();
	const userRole = user?.role;
	const toast = useToast();
	const [showCompanySelectionModal, setShowCompanySelectionModal] = React.useState(false);
	const [companyName, setCompanyName] = React.useState('');

	const updateRoleMutation = useMutation(['updateRole'], updateRole, {
		onSuccess() {
			toast({
				title: 'Role updated successfully',
				type: 'success',
			});
			// reload the page
			window.location.reload();
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				title: `Error while updating role: ${errorMessage}`,
				type: 'error',
			});
		},
	});

	return (
		<div>
			<Modal show={showUpdateRoleModal} size="xl" onClose={() => setShowUpdateRoleModal(false)} dismissible>
				<Modal.Header>
					<h1 className="text-[#1C1C28] dark:text-inherit text-xl font-inter font-[500]">
						Switch Role (Current Role: {userRole})
					</h1>
				</Modal.Header>
				<Modal.Body>
					{userRole && (
						<div className="flex gap-[12px] flex-wrap">
							{user?.allowedRoles?.map((role, index) => {
								if (role === userRole) return null;
								return (
									<Button
										key={index}
										onClick={() => {
											updateRoleMutation.mutate({ newRole: role });
										}}
										color="purplePlaced"
										disabled={updateRoleMutation.isLoading}
									>
										{updateRoleMutation.isLoading ? <Spinner size="sm" light={true} /> : role}
									</Button>
								);
							})}
						</div>
					)}
				</Modal.Body>
			</Modal>
			{/* <CompanySelectionModal
				showCompanySelectionModal={showCompanySelectionModal}
				setShowCompanySelectionModal={setShowCompanySelectionModal}
				setCompanyName={setCompanyName}
			/> */}
		</div>
	);
};

export default UpdateRoleModal;
